import moment from "moment";
import {
  CLASES_RECIBIDAS,
  CLASS_TYPES_RECIBIDOS,
  CREATE_CLASE,
  RESERVATIONS_RECIBIDAS,
  SEMANAS_RECIBIDAS,
  SET_CLASE,
  SET_PROPIEDAD_CLASE,
  SET_MONTH,
  SET_WEEK,
  SET_START_DATE,
  SET_END_DATE,
} from "../types";

const schema = {
  class_instructor_id: "nueva",
  description: "",
  instructor_id: "",
  location_id: "",
  class_type_id: "",
  capacity: "",
  class_date: moment().format("YYYY-MM-DD HH:mm"),
  is_virtual_class: false,
  is_special_event: false,
};

export default (state, { type, payload }) => {
  switch (type) {
    case SEMANAS_RECIBIDAS:
      return { ...state, days: payload };
    case RESERVATIONS_RECIBIDAS:
      return { ...state, reservations: payload };
    case SET_CLASE:
      return { ...state, clase: payload };
    case SET_PROPIEDAD_CLASE:
      const clase = { ...state.clase };
      const { key, value } = payload;
      clase[key] = value;
      return { ...state, clase };
    case CREATE_CLASE:
      return { ...state, clase: schema };
    case CLASS_TYPES_RECIBIDOS:
      return { ...state, class_types: payload };
    case CLASES_RECIBIDAS:
      return { ...state, clases: payload };
    case SET_MONTH:
      return { ...state, month: payload };
    case SET_WEEK:
      return { ...state, selectedWeek: payload };
    case SET_START_DATE:
      return { ...state, start_date: payload };
    case SET_END_DATE:
      return { ...state, end_date: payload };
    default:
      return { ...state };
  }
};
